import {Injectable, EventEmitter} from '@angular/core';
import {Router} from '@angular/router';
import {UrlConfig} from 'config/urlConfig';
import {NetworkService} from 'services/network.service';
import {Constants} from 'config/constants';
import {DashboardDefaults} from '../components/calculator/dashboard/dashboardDefaults';

@Injectable()
export class DashboardService {
    private USAverageEmission = {};
    public USAverageEmission$: EventEmitter<any>;
    public model = {
       totals: {
           trees: 0,
           dollars: 0,
           inDollarsPerMonth: 0
       }
    };

    constructor(protected networkService: NetworkService,
                protected router: Router
    ) {
        this.USAverageEmission$ = new EventEmitter();
    }

    private getUSEmissionFromServer() {
        let prop = {'Region': 'U.S'};
        return this.networkService.post(UrlConfig.getUrl('getRegionAverage'), prop);
    }

    private isEmpty(obj): boolean {
        for (let key in obj) {
            if (obj.hasOwnProperty(key)) {
                return false;
            }
        }
        return true;
    }

    public getCurrentCalculatorName(): string {
        let currentUrl = this.router.url,
            urlArray = currentUrl.split('/');
        return urlArray.splice(1, 1)[0]; // url contains "", calculatorName, categoryName = so we take 1 in array
    }

    public getDefaultData() {
        let calculatorName = this.getCurrentCalculatorName();
        this.model.totals.trees = 0;
        this.model.totals.dollars = 0;
        this.model.totals.inDollarsPerMonth = 0;
        this.model['calculatorName'] = calculatorName;
        this.model['offsetsProductTitles'] = this.objectShadowCopy(DashboardDefaults.offsetsProductTitles);
        this.model['config'] = this.objectShadowCopy(DashboardDefaults.config);
        this.model['totalCategory'] = this.objectShadowCopy(DashboardDefaults.totalCategory);

        if (calculatorName === Constants.calculators.individual) {

            if (this.isEmpty(this.USAverageEmission)) {
                this.getUSEmissionFromServer().subscribe(
                    response => {
                        DashboardDefaults.setAverageCategoryEmission(response[0]);
                        this.model['mtAvgTotal'] = this.objectShadowCopy(DashboardDefaults.mtAvgTotal);
                        this.USAverageEmission = response[0];
                        this.USAverageEmission$.emit({
                            total: this.objectShadowCopy(DashboardDefaults.mtAvgTotal),
                            categories: this.objectShadowCopy(DashboardDefaults.categories[calculatorName])
                        });
                    }
                );
            }
            this.model['mtAvgTotal'] = this.objectShadowCopy(DashboardDefaults.mtAvgTotal);
        }
        this.model['categories'] = this.objectShadowCopy(DashboardDefaults.categories[calculatorName]);
        return this.model;
    }

    onDataChange(data): void {
        let emission = data.emission;
        this.model['totalCategory'].totalEmissions = emission.total;
        this.model.totals.trees = emission.inTrees;
        this.model.totals.dollars = emission.inDollars;
        this.model.totals.inDollarsPerMonth = emission.inDollarsPerMonth;

        for (let key in emission.categories) {
            if (emission.categories.hasOwnProperty(key)) {
                this.model['categories'][key].totalEmissions = emission.categories[key].emission;
                this.model['categories'][key].inTrees = emission.categories[key].inTrees;
                this.model['categories'][key].inDollars = emission.categories[key].inDollars;
                this.model['categories'][key].inDollarsPerMonth = emission.categories[key].inDollarsPerMonth;
            }
        }
    }

    public getCurrentDashboardModel() {
        return this.model;
    }

    private objectShadowCopy(object) {
        return JSON.parse(JSON.stringify(object));
    }
}



// WEBPACK FOOTER //
// ./src/app/services/dashboard.service.ts